import * as React from 'react';
import { Component } from 'react';

import style from './style.scss';


export default function Portfolio(props:any){
    return (
        <div className={style.wrapperVista}>
            <h1>Portfolio</h1>
            <p>
                EN CONSTRUCCION
            </p>
        </div>
    );
}